import { ErrorSpecs } from '@/@vxapp/@ServiceSpecs'

export const Errors = ErrorSpecs
